<template>
  <div class="component-landing-initialization" />
</template>

<script>
export default {
  name: 'LandingInitialization'
}
</script>
